import { ChevronRightIcon } from '@/assets/icons/icons';
import { Flex, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

interface AudienceOptionProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  onClick: () => void;
  showArrow?: boolean;
}

const AudienceOption: React.FC<AudienceOptionProps> = ({
  icon: Icon,
  title,
  description,
  onClick,
  showArrow = false,
}) => (
  <div onClick={onClick} className='audience-option'>
    <Flex gap={16} align='center'>
      {Icon}
      <div>
        <div className='zl-heading-14 font-400'>{title}</div>
        <Text type='secondary' className='zl-para-400-12 color-5e'>
          {description}
        </Text>
      </div>
    </Flex>
    {showArrow && (
      <ChevronRightIcon width={16} height={16} fill='var(--text-primary)' />
    )}
  </div>
);

export default AudienceOption;
